import React from "react";
import {Box, List, ListItem, ListItemButton, ListItemText, Paper, Stack, Typography,} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicList = () => {
    return (
        <Stack spacing={2} p={3}>
            <Box>
                <Typography variant={"h6"} color={"text.primary"}>
                    Basic List
                </Typography>
            </Box>
            <Box sx={{ width: "80%", alignSelf: "center" }}>
                <PreviewAndEditor
                    language="js"
                    background
                    value={"                <List>\n" +
                        "                        <ListItem disablePadding>\n" +
                        "                            <ListItemButton>\n" +
                        "                                <ListItemText primary=\"Inbox\" />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                        <ListItem disablePadding>\n" +
                        "                            <ListItemButton>\n" +
                        "                                <ListItemText primary=\"Drafts\" />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                    </List>"}
                >
                    <Paper p={3} elevation={0} sx={{width: 250}}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary="Inbox" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary="Drafts" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                    </Paper>
                </PreviewAndEditor>
            </Box>
        </Stack>
    );
};

export default BasicList;
